import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const checkExisting = api(async function checkExisting({ input, limit, dimensions } = {}) {
    return query(
        gql`
            query checkExisting($input: String, $limit: Int, $dimensions: Int) {
                checkExisting(input: $input, limit: $limit, dimensions: $dimensions) {
                    key
                    summary
                    similarity
                    bestLine {
                        sentence
                        score
                    }
                }
            }
        `,
        { input, limit, dimensions },
        { returns: "checkExisting" }
    )
})
